import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    FaChartBar, FaExchangeAlt,
    FaCogs, FaUser, FaQuestionCircle, FaThLarge,
    FaBook,
    FaGlobe,
    FaWarehouse,
    FaBoxes,
    FaParking
} from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../composant_reutilisable/sidebar';
import Navbar from '../composant_reutilisable/navbar';
import useAuth from '../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import GlossaireSidebar from '../composant_reutilisable/glossaireSidebar';
import Footer from '../composant_reutilisable/footer';
import { FaMoneyBillTransfer, FaRoadBarrier } from 'react-icons/fa6';

const Menu = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const groupe_id = localStorage.getItem('groupe_id');
    const navigate = useNavigate();
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Accueil";
            fetchUserAccess();
        }
    }, [user_id]);

    const fetchUserAccess = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe_id}`);
            if (response.status === 200) {
                const data = response.data;
                let cleanedAccessArray = [];
                if (Array.isArray(data.acces)) {
                    cleanedAccessArray = data.acces.map((item) =>
                        item.acces
                            ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                            : []
                    ).flat();
                    setAccesGroupe(cleanedAccessArray);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des accès', error);
        } finally {
            setLoading(false);
        }
    };

    // Les éléments principaux du menu
    const menuItems = [
        
        {
            icon: <FaUser />,
            text: 'Tableau de bord',
            link: '/dashboard',
            accessCheck: () => true
        },
        {
            icon: <FaChartBar />,
            text: 'Rapport et statistique',
            link: '/Rapport-et-statistique',
            accessKey: 'Rapport_et_statistique'
        },
        {
            icon: <FaMoneyBillTransfer />,
            text: 'GIE',
            link: '/Parcs-GIE',
            accessKey: 'Gie'
        },
        {
            icon: <FaParking/>,
            text: 'Parc Tampon',
            link: '/Parc-tampon',
            accessKey: 'Parc_tampon'
        },
        {
            icon: <FaExchangeAlt />,
            text: 'Mise en file',
            // getLink: () => accesGroupe.includes('Administration') ? '/Parcs' : '/Gestion-des-tours',
            link: '/Parcs',
            accessCheck: () => (
                accesGroupe.includes('Mise_en_file') ||
                accesGroupe.includes('Fret')
            )
        },
        {
            icon: <FaCogs />,
            text: 'Administration',
            link: '/Admin',
            accessKey: 'Administration'
        },
        // Profil - toujours visible
        {
            icon: <FaUser />,
            text: 'Mon Profil',
            link: '/Mon-profil',
            accessCheck: () => true
        },


        // // Manuel - toujours visible mais avec lien différent selon les droits
        // {
        //     icon: <FaBook />,
        //     text: 'Manuel d\'utilisation',
        //     link: accesGroupe.includes('Administration') ? '/Manuel-utilisation-admin' : '/Manuel-utilisation',
        //     accessCheck: () => true
        // }
    ];

    const handleClick = (lien) => {
        navigate(lien);
    };

    const shouldDisplayItem = (item) => {
        if (item.accessCheck) {
            return item.accessCheck();
        }
        return accesGroupe.includes(item.accessKey);
    };

    const [showGlossary, setShowGlossary] = useState(false);

    if (loading) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Chargement...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaThLarge size={25} className='mr-2' /> Accueil
                                </div>
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        Accueil
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (
                                shouldDisplayItem(item) && (
                                    <div key={index} className="col-md-2 mb-4">
                                        <div
                                            className="card rounded shadow-sm h-100"
                                            onClick={() => handleClick(item.getLink ? item.getLink() : item.link)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body d-flex flex-column align-items-center">
                                                <div className="mb-3 icon-medium" style={{ fontSize: '2rem' }}>
                                                    {item.icon}
                                                </div>
                                                <h5 className="text-center">
                                                    <Link
                                                        className='text-dark'
                                                        to={item.link}
                                                        style={{ textDecoration: 'none' }}
                                                    >
                                                        {item.text}
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Menu;